/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tipArrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 41 38',
    data: '<defs><clipPath id="clip-path"><path pid="0" class="cls-1" transform="rotate(-78.94 20.497 18.998)" d="M6.48 8.31h28.05v21.38H6.48z"/></clipPath></defs><g class="cls-2"><path pid="1" class="cls-3" d="M26.81 6a.42.42 0 0 0-.26.08l-7.66 5.16a.46.46 0 1 0 .52.77l6.76-4.55-2.3 11.74A13.56 13.56 0 0 1 8 29.89a.47.47 0 0 0-.18.92 14.55 14.55 0 0 0 17-11.43l2.23-11.63 4.45 6.61a.45.45 0 0 0 .64.13.56.56 0 0 0 .16-.35l.05-.28-5.07-7.56a.44.44 0 0 0-.36-.3h-.11zm0 0"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/tipArrow.js